import { Box, CircularProgress, Typography } from "@mui/material";
import { makeSxStyles } from "ui";

interface MapLoadingProps {
  hasLiveStateChanges?: boolean;
}

const useStyles = makeSxStyles(() => ({
  container: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "#ffffff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1002,
  },
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 2,
  },
}));

const MapLoading = ({ hasLiveStateChanges }: MapLoadingProps) => {
  const styles = useStyles();

  return (
    <Box
      sx={{
        ...styles.container,
        borderRadius: hasLiveStateChanges ? "0" : "4px",
      }}
    >
      <Box sx={styles.content}>
        <CircularProgress size={50} color="primary" />
        <Typography variant="h6" color="text.primary" fontWeight={500}>
          Loading map...
        </Typography>
      </Box>
    </Box>
  );
};

export default MapLoading;
